import { ColumnTable, Table } from '@octano/global-ui';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import TableEmptyContent from '../../../../components/text/TableEmptyContent';
import { TranslationsKeys } from '../../../../locales/translations';
import { CourseGroupListItem } from '../types';

interface CourseGroupTableProps {
  items: CourseGroupListItem[];
  total: number;
  totalPages: number;
  page: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  columns: ColumnTable<CourseGroupListItem>[];
  loading?: boolean;
  isSearch?: boolean;
}

/**
 * HU 15564 — Task FE-B: wrapper delgado sobre <Table> de @octano/global-ui
 * con paginación + estado vacío diferenciado entre "sin datos" y "sin
 * resultados de búsqueda".
 */
export default function CourseGroupTable({
  items,
  total,
  totalPages,
  page,
  itemsPerPage,
  onPageChange,
  columns,
  loading,
  isSearch,
}: CourseGroupTableProps): ReactElement {
  const { t } = useTranslation(TranslationsKeys.COURSE_GROUPS);

  return (
    <Table<CourseGroupListItem>
      columns={columns}
      data={items}
      isLoadingResults={loading}
      pagination={{
        currentPage: page,
        itemsPerPage,
        totalItems: total,
        totalPages,
        onChangePage: onPageChange,
      }}
      noResultsText={
        <TableEmptyContent
          title={t(
            isSearch ? 'list.table.emptySearchTitle' : 'list.table.emptyTitle',
          )}
          subtitle={t(
            isSearch
              ? 'list.table.emptySearchSubtitle'
              : 'list.table.emptySubtitle',
          )}
        />
      }
    />
  );
}
